import * as ambassadorWixLoyaltyV1Coupon from './loyalty-v1-coupon-coupons.http.js';
import * as ambassadorWixLoyaltyV1CouponTypes from './loyalty-v1-coupon-coupons.types.js';
import * as ambassadorWixLoyaltyV1CouponUniversalTypes from './loyalty-v1-coupon-coupons.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function redeemPointsForCoupon(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1CouponUniversalTypes.RedeemPointsForCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.RedeemPointsForCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.RedeemPointsForCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.RedeemPointsForCouponResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.redeemPointsForCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/coupons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function redeemCurrentMemberPointsForCoupon(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1CouponUniversalTypes.RedeemCurrentMemberPointsForCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.RedeemCurrentMemberPointsForCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.RedeemCurrentMemberPointsForCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.RedeemCurrentMemberPointsForCouponResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.redeemCurrentMemberPointsForCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/coupons/redeem-my-coupon',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLoyaltyCoupon(): __PublicMethodMetaInfo<
  'GET',
  { loyaltyCouponId: string },
  ambassadorWixLoyaltyV1CouponUniversalTypes.GetLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.GetLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.GetLoyaltyCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.GetLoyaltyCouponResponse
> {
  const payload = { loyaltyCouponId: ':loyaltyCouponId' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.getLoyaltyCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/coupons/{loyaltyCouponId}',
    pathParams: { loyaltyCouponId: 'loyaltyCouponId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetLoyaltyCoupon(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1CouponUniversalTypes.BulkGetLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.BulkGetLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.BulkGetLoyaltyCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.BulkGetLoyaltyCouponResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.bulkGetLoyaltyCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/bulk/coupons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrentMemberCoupons(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1CouponUniversalTypes.GetCurrentMemberCouponsRequest,
  ambassadorWixLoyaltyV1CouponTypes.GetCurrentMemberCouponsRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.GetCurrentMemberCouponsResponse,
  ambassadorWixLoyaltyV1CouponTypes.GetCurrentMemberCouponsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.getCurrentMemberCoupons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/coupons/my-coupons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLoyaltyCoupons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1CouponUniversalTypes.QueryLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.QueryLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.QueryLoyaltyCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.QueryLoyaltyCouponResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.queryLoyaltyCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/coupons/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLoyaltyCoupon(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixLoyaltyV1CouponUniversalTypes.DeleteLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponTypes.DeleteLoyaltyCouponRequest,
  ambassadorWixLoyaltyV1CouponUniversalTypes.DeleteLoyaltyCouponResponse,
  ambassadorWixLoyaltyV1CouponTypes.DeleteLoyaltyCouponResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Coupon.deleteLoyaltyCoupon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/coupons/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyCoupon as LoyaltyCouponOriginal,
  CouponReference as CouponReferenceOriginal,
  Specification as SpecificationOriginal,
  SpecificationTypeDetailsOneOf as SpecificationTypeDetailsOneOfOriginal,
  SpecificationScopeOrMinSubtotalOneOf as SpecificationScopeOrMinSubtotalOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  BuyXGetY as BuyXGetYOriginal,
  Scope as ScopeOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  RedeemPointsForCouponRequest as RedeemPointsForCouponRequestOriginal,
  RedeemPointsForCouponResponse as RedeemPointsForCouponResponseOriginal,
  RedeemCurrentMemberPointsForCouponRequest as RedeemCurrentMemberPointsForCouponRequestOriginal,
  RedeemCurrentMemberPointsForCouponResponse as RedeemCurrentMemberPointsForCouponResponseOriginal,
  RedeemMemberPointsForDiscountAmountCouponRequest as RedeemMemberPointsForDiscountAmountCouponRequestOriginal,
  RedeemMemberPointsForDiscountAmountCouponResponse as RedeemMemberPointsForDiscountAmountCouponResponseOriginal,
  GetLoyaltyCouponRequest as GetLoyaltyCouponRequestOriginal,
  GetLoyaltyCouponResponse as GetLoyaltyCouponResponseOriginal,
  BulkGetLoyaltyCouponRequest as BulkGetLoyaltyCouponRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  BulkGetLoyaltyCouponResponse as BulkGetLoyaltyCouponResponseOriginal,
  CouponsInSite as CouponsInSiteOriginal,
  GetCurrentMemberCouponsRequest as GetCurrentMemberCouponsRequestOriginal,
  GetCurrentMemberCouponsResponse as GetCurrentMemberCouponsResponseOriginal,
  QueryLoyaltyCouponRequest as QueryLoyaltyCouponRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  QueryLoyaltyCouponResponse as QueryLoyaltyCouponResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  DeleteLoyaltyCouponRequest as DeleteLoyaltyCouponRequestOriginal,
  DeleteLoyaltyCouponResponse as DeleteLoyaltyCouponResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-v1-coupon-coupons.types.js';
